import type { LedgerEvent } from './types.ts';

// Both live funds finished reconciling the migration by this timestamp.
const JUPITER_MIGRATION_RESOLVED_AT = 1790629565308;

/** Keep resolved migration diagnostics out of the website and public API. */
export function isPublicEvent(event: LedgerEvent): boolean {
  if (/^Creator fee sweep incomplete: sweep not confirmed in time\b/.test(event.message)) return false;
  if (/^Creator fee claim failed: Signature \S+ has expired: block height exceeded\.?$/.test(event.message)) return false;
  if (/^open_tranche on (BTC|ETH|SOL) failed: You must call `subscribe` or `fetch` before using this function$/.test(event.message)) return false;
  if (event.kind === 'error' && event.ts <= JUPITER_MIGRATION_RESOLVED_AT) {
    if (/^open_tranche on (BTC|ETH|SOL) failed: Invalid Jupiter monetary amount$/.test(event.message)) return false;
    if (/^Venue unavailable, .*\bdrift\b/i.test(event.message)) return false;
  }
  return true;
}

/** Public copy uses a generic execution-service name. */
export function publicMessage(message: string): string {
  return message.replace(/https?:\/\/[^\s]*jup\.ag[^\s]*/gi, 'the trading service')
    .replace(/jupiter(?: perps)?/gi, 'exchange');
}
export function publicEvent(event: LedgerEvent): LedgerEvent {
  return { ...event, message: publicMessage(event.message) };
}
